export type AppEnv = 'local' | 'preview' | 'staging' | 'production';

const DEFAULT_LOCAL_API = 'http://127.0.0.1:8080';
const DEFAULT_PRODUCTION_API = '';

function normalizeUrl(value: string): string {
  return value.replace(/\/+$/, '');
}

function inferDefaultApiBaseUrl(): string {
  if (typeof window === 'undefined') return DEFAULT_LOCAL_API;
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return DEFAULT_LOCAL_API;
  }
  return DEFAULT_PRODUCTION_API;
}

function isAppEnv(value: string | undefined): value is AppEnv {
  return value === 'local' || value === 'preview' || value === 'staging' || value === 'production';
}

function inferDefaultAppEnv(): AppEnv {
  if (typeof window === 'undefined') return 'local';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return 'local';
  if (host.endsWith('.pages.dev')) return 'preview';
  return 'production';
}

const resolvedAppEnv: AppEnv = isAppEnv(import.meta.env.VITE_APP_ENV) ? import.meta.env.VITE_APP_ENV : inferDefaultAppEnv();

export const appEnv = {
  apiBaseUrl: normalizeUrl(import.meta.env.VITE_CHAOC_API_BASE_URL || inferDefaultApiBaseUrl()),
  maptilerKey: import.meta.env.VITE_MAPTILER_KEY || '',
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '',
  fixturesEnabled: import.meta.env.DEV && import.meta.env.VITE_ENABLE_FIXTURES === 'true',
  appEnv: resolvedAppEnv,
  appVersion: import.meta.env.VITE_APP_VERSION || __APP_VERSION__,
};

export function isProductionLike(): boolean {
  return appEnv.appEnv === 'production' || appEnv.appEnv === 'staging';
}
